import { render, staticRenderFns } from "./listaCategoria.vue?vue&type=template&id=6a3a4285&scoped=true&"
import script from "./listaCategoria.vue?vue&type=script&lang=js&"
export * from "./listaCategoria.vue?vue&type=script&lang=js&"
import style0 from "./listaCategoria.vue?vue&type=style&index=0&id=6a3a4285&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3a4285",
  null
  
)

export default component.exports